module.exports = __webpack_public_path__ + "static/media/BH-Pharaoh-Gold.accd28be.png";